module.exports = "pegasus_template/assets/background-patterns/fall-default-theme.jpg";